import { ImageProps } from "@shared/components/Image";
import { create } from "zustand";

interface ChatImageGalleryState {
  isOpen: boolean;
  // TODO: Improve this implementation to support multiple images
  image: ImageProps | null;
}

interface ChatImageGalleryActions {
  setChatGalleryImage: (image: ImageProps | null) => void;
}

const initState: ChatImageGalleryState = {
  isOpen: false,
  image: null,
};

type ChatImageGalleryStore = ChatImageGalleryState & ChatImageGalleryActions;

export const useChatImageGalleryStore = create<ChatImageGalleryStore>(
  (set) => ({
    ...initState,
    setChatGalleryImage: (image) =>
      set(() => ({
        image,
        isOpen: !!image,
      })),
  })
);
